import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ServiceIntro from '../../components/ServiceIntro/ServiceIntro';
import ProductList from '../../components/ProductList/ProductList';
import productsData from '../../data/products.json';

const tradeContent = {
  title: "综合类大数据与分析系统",
  // subtitle: "综合类大数据分析系统致力于为各类企业提供全方位的数据解决方案，整合企业内外数据资源，深度挖掘数据潜在价值，提升企业决策质量与效率。平台涵盖数据洞察分析、智能检索、趋势预测、策略优化和数据质量管理等多种功能模块，全面满足企业在不同业务场景下对数据分析和决策的多样需求。",
  description: {
    mainText: "综合类大数据分析系统致力于为各类企业提供全方位的数据解决方案，整合企业内外数据资源，深度挖掘数据潜在价值，提升企业决策质量与效率。平台涵盖数据洞察分析、智能检索、趋势预测、策略优化和数据质量管理等多种功能模块，全面满足企业在不同业务场景下对数据分析和决策的多样需求。",
    systemTitle: "产品体系及优势：",
    systems: [
      "智源大数据洞察与分析平台：高效分析企业运营及市场趋势，辅助战略规划和运营优化。",
      "数极数据仓库与智能检索系统：快速整合企业多源数据，实现毫秒级查询响应，提高数据管理效率。",
      "思塔数据驱动业务洞察与策略优化平台：提供深入市场洞察与策略仿真能力，持续优化企业经营策略。",
      "先见数据流与趋势预测引擎：精准预测业务趋势，实时预警风险，确保企业及时响应市场变化。",
      "合能数据整合与价值挖掘管理系统：高效融合企业内外部数据，深度挖掘数据价值，提升整体决策质量。",
      "精核数据质量监控与优化软件：全方位保障数据质量与数据准确性，提升决策基础的可靠性。"
    ],
    conclusion: {
      title: "为什么选择我们的解决方案？",
      content: ["我们拥有专业的数据分析与应用团队，基于多年跨行业的数据处理与应用经验，能够快速、精准地理解企业业务痛点，提供针对性的大数据解决方案。平台功能模块化，可灵活组合部署，满足企业不同发展阶段的需求。",
        "通过综合类大数据分析系统，企业可以全面提升数据应用效率，实现更精准、更高效、更智能的业务决策，确保企业始终站在市场前沿。"
      ]
    }
  },
  image: "/images/solutions/bigData.png",

};

export const tradeProducts = {
  title: "我们的产品",
  subtitle: "综合类大数据与分析系统",
  products: productsData.products
};

const Trade = () => {
  return (
    <div className="trade-page flex flex-col min-h-screen">
      <Navbar />
      <ServiceIntro {...tradeContent} />
      <ProductList {...tradeProducts} />
      <div className='mt-auto' style={{ backgroundColor: '#f8f9fa' }}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Trade; 